import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import Loader from "../../../utils/Loader";
import { fill_action } from "../../../actions/fillList_action";
import { toast } from "react-toastify";
import Header from "../../../common_components/Header";
import { invoices_list_action } from "../../../actions/accounts_action/account_invoices_action";
import moment from "moment";
import Pagination from "../../../utils/pagination";
import { Modal, Button } from "react-bootstrap";
import { download_tax_invoice_action } from "../../../actions/myOrders_action/myOrders_action";
import { downloadReport, sessionExpireMessage, tokenInavlidMessage } from "../../../utils/constants";


class InvoicesList extends Component {
    constructor(props) {
        super(props);
        this.state = {
          isLoading: false,
          PiShow:false,
          isAccordionExpanded: false,
          currentPage: 1,
          userId: "",
          OrderID: "",
          OrderNo: "",
          OrderDate: "",
          CompanyName: "",
          ProformaInvoiceID: "",
          ProformaInvoice_No: "",
          ClientID: "",
          PrimaryEmailID: "",
          ItmeCenter: "",
          CenterID: "",
          BookingDate: "",
          Is_Proforma: "",
          OrderAmount: "",
          OutStanding: "",
          BlockedDate: "",
          RoleID: "",
          CurrentRole:"",
          invoicesData: [], proformaList:[],
        };
        this.invoicesList = this.invoicesList.bind();
        this.updateItem = this.updateItem.bind(this);
      }
      async componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
          
          setTimeout(() => {
            this.props.navigate("/login");
          }, 500);
        }
        setTimeout(() => {
          {
            sessionStorage.getItem("roleId") == 4 ? (
              this.props.navigate("/checkList")
            ) : (
              <></>
            );
          }
        }, 10);
      this.setState({CurrentRole:sessionStorage.getItem("roleId")},()=>{
       
      })
            
              
        const { userId } = this.state;
    
        this.setState({
          userId:
            sessionStorage.getItem("userId") == "" ||
            sessionStorage.getItem("userId") == null
              ? ""
              : sessionStorage.getItem("userId"),
          FormData: localStorage.getItem("FromDate"),
          ToDate: localStorage.getItem("ToDate"),
        });
        try {
          await this.invoicesList();
        } catch (error) {
          console.error(error);
        }
      }
      onPreviewNavigate(
        OrderID,
        OrderNo,
        ClientID,
        DeliveryStatus,
        ProformaInvoiceID,
        ProformaInvoice_No,
        CompanyName,
        PrimaryEmailID,
        CenterID,
      ) {
        this.props.navigate(sessionStorage.getItem("roleId") == 2 ? "/ordersEdit" : "/my_orders_edit", {
          state: {
            OrderID: OrderID,
            OrderNo: OrderNo,
            ClientID: ClientID,
            DeliveryStatus: DeliveryStatus,
            ProformaInvoiceID: ProformaInvoiceID,
            ProformaInvoice_No: ProformaInvoice_No,
            CompanyName: CompanyName,
            PrimaryEmailID: PrimaryEmailID,
            CenterID: CenterID,
          },
        });
      }
      downloadPerformaInvoice(ProformaInvoiceID, ProformaInvoice_No) {
        const { userId } = this.state;
        const formattedProformaInvoiceNo = ProformaInvoice_No.replace(
          /[\/-]/g,
          "_"
        );
        this.setState({ isLoading: true });
      
        if (ProformaInvoiceID) {
          this.props
            .download_tax_invoice_action(
              userId,
              ProformaInvoiceID,
              formattedProformaInvoiceNo
            )
            .then((downloadData) => {
              if (downloadData.error !== 1) {
                this.setState({ isLoading: false });
                console.log(downloadData);
      
                // Open the report in a new tab
                const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
                window.open(url, "_blank");
              } else {
                if(downloadData.msg == sessionExpireMessage || downloadData.msg == tokenInavlidMessage){
                  //after session expire.....................
                  sessionStorage.clear()
                  this.props.navigate('/normalView')
                  setTimeout(() => {
                    toast.error(downloadData.msg, {
                      position:"top-center",
                      theme: "colored",
                      autoClose: 3000,
                      hideProgressBar: true,
                    });
                  }, 500);
              }else{
                this.setState({ isLoading: false });
                toast.error(downloadData.msg,{
                  position:"top-center",autoClose:1000,hideProgressBar:true,theme:"colored"
                });
              }}
            })
            .catch((err) => {
              console.log(err);
              this.setState({ isLoading: false });
            });
        } else {
          this.setState({ isLoading: false });
          toast.error("Cannot open: Proforma Invoice ID not found.",{
            position:"top-center",autoClose:1000,hideProgressBar:true,theme:"colored"
          });
        }
      }
      invoicesList = async () => {
        const { userId, OrderID, CompanyName,ItmeCenter } = this.state;
        this.setState({ isLoading: true });
        try {
          const data = await this.props.invoices_list_action(
            OrderID,
            CompanyName,ItmeCenter
          );
          if (data.error !== 1) {
            this.setState({
              invoicesData: data.data,
              proformaList: data.data,
              isLoading: false,
              currentpage: 1,
            });
          } else {
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(data.msg, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        } catch (error) {
          console.error(error);
        }
    
        // localStorage.setItem("FromDate", FromDate);
        // localStorage.setItem("ToDate", ToDate);
      };
      updateItem(item) {
        this.setState({ currentPage: item });
      }
      invoicesRecord(invoicesData) {
        return (
          <table class="table table-bordered table-striped" id="dashboard-table">
            <thead>
              <tr>
                <th>Application No</th>
                <th>Company Name</th>
                <th>Venue</th>
                <th>Dates</th>
                <th>Order No</th>
                <th class="text-center">Tax Invoice</th>
                <th class="text-right" style={{ width: "8%" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody id="myTable">
              {invoicesData.length > 0 ? (
                invoicesData.map((data, i) => (
                  <tr>
                    <td>{data.OrderID}</td>
                    <td>{data.CompanyName}</td>
                    <td>{data.Venue}</td>
                    <td>
                      {data.BookingDate
                        ? moment(data.BookingDate, "DD/MM/YYYY").format(
                            "DD-MM-YYYY"
                          )
                        : "Not Available"}
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        title="Navigate to Order"
                        class="btn btn-sm"
                        onClick={() =>
                          this.onPreviewNavigate(
                            data.OrderID,
                            data.OrderNo,
                            data.ClientID,
                            data.DeliveryStatus,
                            data.ProformaInvoiceID,
                            data.ProformaInvoice_No,
                            data.CompanyName,
                            data.PrimaryEmailID,
                            data.CenterID
                          )
                        }
                      >
                        {data.OrderNo}
                      </a>
                    </td>
                    <td class="text-center"><a
                          title="Show Proforma"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            this.downloadPerformaInvoice(
                              data.ProformaInvoiceID,
                              data.ProformaInvoice_No
                            )
                          }
                        >
                          <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                        </a></td>
                    
                    <td class="text-right">
                      <a
                        href="javascript:void(0);"
                        title="Navigate to Order"
                        class="btn btn-sm"
                        onClick={() =>
                          this.onPreviewNavigate(
                            data.OrderID,
                            data.OrderNo,
                            data.ClientID,
                            data.DeliveryStatus,
                            data.ProformaInvoiceID,
                            data.ProformaInvoice_No,
                            data.CompanyName,
                            data.PrimaryEmailID,
                            data.CenterID
                          )
                        }
                      >
                        <i class="fa fa-eye action_btn_table"></i>
                      </a>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10">No data available.</td>
                </tr>
              )}
            </tbody>
          </table>
          
        );
      }
    
      render() {
        const {PiShow,
          isLoading,
          isAccordionExpanded,
          userId,
          OrderID,
          OrderNo,
          OrderDate,
          CompanyName,
          ProformaInvoiceID,
          ProformaInvoice_No,
          ClientID,
          PrimaryEmailID,
          ItmeCenter,
          CenterID,
          BookingDate,
          Is_Proforma,
          OrderAmount,
          OutStanding,
          BlockedDate,
          invoicesData,
          currentPage,proformaList
        } = this.state;
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        const currentRecords = invoicesData.slice(
          indexOfFirstRecord,
          indexOfLastRecord
        );
        const nPages = Math.ceil(invoicesData.length / recordsPerPage);
        return (
          <>
            {isLoading ? <Loader></Loader> : null}
            <>
              <main id="main">
                <Header data={[14]} />
                <section style={{ marginTop: "115px" }}>
                  <div class="container-fluid">
                    <div class="page-header">
                      <h4 class="page-title">Invoices List</h4>
                      
                    </div>
    
                    <div class="search_accordion search_card">
                      <div class="panel-group" id="accordion">
                        <div class="panel panel-default">
                          <div
                            className="panel-heading accordion-toggle collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion"
                            data-target="#collapseOne"
                            aria-expanded={isAccordionExpanded}
                            onClick={() =>
                              this.setState({
                                isAccordionExpanded: !isAccordionExpanded,
                              })
                            }
                          >
                            <h4 class="panel-title">Search</h4>
    
                            <div class="searched_items">
                              <h5>
                                Company : <span>{CompanyName}</span>
                              </h5>
                              <h5>
                                Venue : <span>{ItmeCenter}</span>
                              </h5>
                              <h5>
                                Application No : <span>{OrderID}</span>
                              </h5>
                            </div>
                          </div>
                          <div
                            id="collapseOne"
                            className={`panel-collapse collapse ${
                              isAccordionExpanded ? "show" : ""
                            }`}
                          >
                            <div class="panel-body">
                              <div class="row mr_0">
                                <div class="col-md-2">
                                  <div class="form-group">
                                    <label>Company</label>
                                    <input
                                      type="text"
                                      value={CompanyName}
                                      onChange={(e) =>
                                        this.setState({ CompanyName: e.target.value })
                                      }
                                      className="form-control search_form_control"
                                      placeholder="Company Name"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-2">
                                  <div class="form-group">
                                    <label>Venue</label>
                                    <input
                                     value={ItmeCenter}
                                     onChange={(e) =>
                                       this.setState({ ItmeCenter: e.target.value })
                                     }
                                      type="text"
                                      class="form-control search_form_control"
                                      placeholder="Venue"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-2">
                                  <div class="form-group">
                                    <label>Application No</label>
                                    <input
                                     value={OrderID}
                                     onChange={(e) =>
                                       this.setState({ OrderID: e.target.value })
                                     }
                                      type="text"
                                      class="form-control search_form_control"
                                      placeholder="Application No"
                                    />
                                  </div>
                                </div>
    
                                <div class="col-md-1">
                                  <label>&nbsp;</label>
                                  <button onClick={()=>this.invoicesList()} class="btn btn-primary search_btn ">
                                    Search
                                  </button>
                                </div>
                                <div class="col-md-1">
                                  <label>&nbsp;</label>
                                  <button onClick={()=>window.location.reload()} class="btn btn-primary search_btn">
                                    Clear
                                  </button>
                                </div>
                                
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
    
                    <div class="custom_table">
                      <div class="hack1">
                        <div class="hack2">
                          {this.invoicesRecord(currentRecords)}
                          {isLoading == true ? null : (
                            <Pagination
                              nPages={nPages}
                              currentPage={currentPage}
                              setCurrentPage={this.updateItem}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              
              </main>
            </>
          </>
        );
      }
}
export default withRouter(
    connect(null, {
      fill_action,
      invoices_list_action,download_tax_invoice_action
    })(InvoicesList)
  );
  